"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var styles = {
  "spinner": "styles-spinner-3zm_K",
  "indeterminate": "styles-indeterminate-24wOy",
  "rotate": "styles-rotate-z1bpa",
  "dash": "styles-dash-3eBVm"
};

var progressValues = function progressValues(value, max) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 9 : _ref$radius;

  if (value == null) return null;
  var length = Math.round(2 * Math.PI * radius);
  var filled = Math.min(Math.round(value / max * length), length);
  var empty = length - filled;
  return [filled, empty].join(' ');
};

var ProgressSpinner = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
      className = _ref2.className,
      value = _ref2.value,
      _ref2$max = _ref2.max,
      max = _ref2$max === void 0 ? 1.0 : _ref2$max,
      htmlProps = (0, _objectWithoutProperties2["default"])(_ref2, ["children", "className", "value", "max"]);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    ref: ref,
    className: _utils.classNames.use(styles.spinner, value == null && styles.indeterminate).join(className),
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, htmlProps), /*#__PURE__*/_react["default"].createElement("circle", {
    strokeWidth: "2",
    strokeLinecap: "butt",
    strokeDasharray: progressValues(value, max),
    cx: "12",
    cy: "12",
    r: "9"
  }), children);
});
var _default = ProgressSpinner;
exports["default"] = _default;